module.exports = __webpack_public_path__ + "img/sit-poland-logo.ba4ccdcd.png";